import { render, staticRenderFns } from "./Password-setup.vue?vue&type=template&id=59396cc0&"
import script from "./Password-setup.vue?vue&type=script&lang=js&"
export * from "./Password-setup.vue?vue&type=script&lang=js&"
import style0 from "./Password-setup.vue?vue&type=style&index=0&id=59396cc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports